export default "__VITE_ASSET__COXSBu7a__"